import { ERROR_CODES } from '@/model/ERROR_CODES'
let pendingRegistrationCall = false

/**
 *
 * Register a user
 *
 * this method should only be called on form submit and only once
 *
 * @returns {Promise.<T>}
 */
function registerUser(data: GD_userRegistration.RegistrationData) {
  if (pendingRegistrationCall) return

  pendingRegistrationCall = true

  return fetch('/gd/rest/userRegistration/register', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
    cache: 'no-cache',
  })
    .then((response) => response.json())
    .then((response: GD_userRegistration.RegisterResponse) => {
      pendingRegistrationCall = false
      if (response === '') {
        throw ERROR_CODES.nameErrorUnknown
      } else {
        //verify the backend was fine with the data and created successfully
        return response
      }
    })
    .catch((err) => {
      pendingRegistrationCall = false
      throw err
    })
}

export { registerUser }
